<template>
   <div id="userLogin">
        <div>
            <div class="big-img">
                <img src="./../../../assets/xxtx.jpg"   alt="" class="yema-big-img">
            </div>
            <h2> 
                <!-- <img src="./../../assets/yema.jpg" alt="" class="yema-img"> -->
                <span>请输入卡片背面数字</span>
            </h2>
            <form>        
                <div>
                    <keep-alive>
                        <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch"  @select="handleSelect" placeholder="请输入卡片背面数字"></se-autocomplete>
                    </keep-alive>
                </div>
              <p style="text-align: center;font-size: 16px;margin-top:1rem;color:red">温馨提醒：本产品暂无通话短信功能! </p>
                <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIM">查询</mt-button> 
                    <br/>
                      <mt-button type="primary" size="large" @click.prevent="kefuURl">联系客服</mt-button> 
                      <button class="download" @click.prevent="kefuURl">联系客服</button>
                </div>
            </form>
        </div>

    <!-- <p style="text-align: center;font-size: 10px;margin-top:1rem">提醒：电信卡如需注销实名，请联系客服处理。</p> -->
    <!-- <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/advertising3.jpg"
      alt=""
      @click="goto('http://szyanyun.com/download.html')"
    /> -->
  

    <!-- <Advertisement></Advertisement> -->
  

  </div>
</template>
<script>
import {Dialog} from "vant";
import {Toast} from "vant";
import {wxRequest} from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: {SeAutocomplete, Advertisement},
  data() {
    return {
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
      isWx:false,
      isCode:'0'
    };
  },
  methods: {
    kefuURl(){
      window.location.href='http://kefu.szxxtx.com/s/135302p4tv'
    },
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      // Dialog({ message: '系统维护中' });
      // return;
      if (!this.iccid || this.iccid == "") {
        Dialog.alert({title: "提示", message: "请输入ICCID号"});
        return false;
      }

      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.iccid,
        code: this.code,
        isCode:this.isCode
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("openId",record.openId);
          localStorage.setItem("virtualNo",record.virtualNo);

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          // this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);

          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          this.setAutoCompleteData("iccidList", recordLoginText, 10);
          localStorage.setItem("iccid", iccid);
          //判断有没有购买过套餐  如果购买过套餐 直接跳转实名页面
	     	wxRequest("sim/is/have/pkg", {iccid: iccid}, "get").then(res => {
             if(res.data.code == 200){
               this.$router.replace("/user/home");
			       }else{
                this.$router.push({
						path: '/user/cardOpen',
						query: {
							realNameCard: 1
						}})
             }
        })         
        } else {
          Dialog.alert({title: "提示", message: res.data.message});
        }
      });
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    goto(path) {
      //广告点击统计
      window.location.href = path;
    },
  },
  created() {

   //判断是不是在微信环境中
	 var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
       this.isWx=true;
    } 
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source ? source : process.env.VUE_APP_APPID;
    if(this.isWx){
        localStorage.setItem("isCode", true);
       console.log(appid);
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      this.iccid = localStorage.getItem("recordLoginText");
    }
    }else{
      localStorage.setItem("isCode", false);
      this.code = '1';
      this.isCode='1';
      this.iccid = localStorage.getItem("recordLoginText");
    }
    //获取总部公众号appid
    wxRequest("sim/appId", {}, "post").then((res) => {
      if (res.data.code == 200) {
        if (appid != res.data.data.collectAppid) {
          this.$store.commit("setIsHeadquarterAppid", "false");
          localStorage.setItem("isHeadquarterAppid", false);
        } else {
          this.$store.commit("setIsHeadquarterAppid", "true");
          localStorage.setItem("isHeadquarterAppid", true);
        }
      }
    });
  },

  mounted() {},

  beforeDestory() {},
};
</script>

<style lang="less" scoped>
.download {
  position: relative;
  top: 63px;
  background: #ff9c3c;
  border: none;
  padding: 20px 13px;
  border-radius: 25px;
  font-size: 12px;
  color: #fff;
  left: 85%;
}
.big-img {
    text-align: center;
}
.yema-big-img {
    height: 230px;
}
</style>
